var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12357_9216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13037 0.252075C5.27529 0.435381 13.4521 3.4416 12.9999 14",
    stroke: "#B9B9B9",
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4536 0.252075C21.3087 0.435381 13.1319 3.4416 13.5841 14",
    stroke: "#B9B9B9",
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.16666,
    height: 10.7692,
    transform: "matrix(-1 0 0 1 2.1665 0)",
    fill: "#886C42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.16666,
    height: 10.7692,
    transform: "matrix(-1 0 0 1 26 0)",
    fill: "#886C42"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.7693,
    width: 1.08333,
    height: 3.23077,
    fill: "#C9B15E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9165,
    y: 10.7693,
    width: 1.08333,
    height: 3.23077,
    fill: "#C9B15E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12357_9216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.8139f120721f8aa6c5ae222b4f55617c.svg";
export { ForwardRef as ReactComponent };